import React from "react";

export const PrjListFull: React.FC = ({ children }) => {
  return <div className="prj__col-wrapper-full">{children}</div>;
};
